import React, {useState, useEffect} from 'react';
import {DateField, Edit, SimpleForm, TextInput, ImageInput, ImageField, SelectInput, GET_LIST} from 'react-admin'
import {required} from "../../validators";
import EditActions from "../../custom/common/EditActions";
import EditToolbar from "../../custom/common/EditToolbar";
import {dataProvider} from "../../App";

const typeChoices = [
  {id : "notice", name : "notice"},
  {id : "event", name : "event"},
]

export default (props) => {
  const [siteChoices, setSiteChoices] = useState([]);
  
  useEffect(()=>{
    dataProvider(
      GET_LIST,
      'sites',
      {}
    ).then(result => setSiteChoices(result.data));
  }, [])

  return (
    <Edit {...props} actions={<EditActions/>}>
    <SimpleForm toolbar={<EditToolbar/>}>
      <TextInput disabled source='id'/>
      <SelectInput source='siteId' choices={siteChoices} validate={required}/>
      <SelectInput source='type' choices={typeChoices} validate={required}/>
      <TextInput source='title'validate={required}/>
      <TextInput multiline source='content' style={{width : '100%'}}/>
      <ImageInput source="image">
        <ImageField source="src" title="title"/>
      </ImageInput>
      <DateField source="createdAt" locales='ko' showTime/>
    </SimpleForm>
  </Edit>
  )
}